/** 简体中文 */
export default {
  lang_zh_hans: '简体中文',
  lang_zh_hant: '繁體中文',
  lang_en: 'English',
  lang_picker_title: '选择语言',
  lang_switch: '语言切换',
  lang_current: '当前语言',

  common_back: '返回',
  common_cancel: '取消',
  common_ok: '确定',
  common_confirm: '确认',
  common_close: '关闭',
  common_query: '查询',
  common_setting: '设置',
  common_save: '保存',
  common_submit: '提交',
  common_loading: '加载中...',
  common_empty: '空空如也',
  common_tip: '提示',
  common_yuan: '元',
  common_scan: '扫码',
  common_scan_get: '扫码获取',
  common_scan_error: '扫码异常',
  common_please_enter: '请输入',
  common_exit_system: '退出系统?',
  common_retry: '重试',
  common_filter: '筛选',
  common_date: '日期',
  common_all: '所有',
  net_error_reconnect: '处理中{0}s ',
  brand_hst: '惠商通',
  brand_epay: 'SPayPOS',
  brand_spay: 'SPayPOS',

  home_loading: '数据加载中...',
  home_query: '查询',
  home_zbf: '桌边付',
  home_setting: '设置',
  home_exit: '退出',
  home_set_outlet: '请设置营业点',
  home_discount_trade: '优惠交易',
  home_cashier: '收银',
  home_refund: '退款',

  setting_title: '设置',
  setting_param: '参数设置',
  setting_maintenance: '维护手册',
  setting_device_info: '设备信息',
  setting_logon: '签到',
  setting_print_bill: '打印账单',
  setting_upload: '日志上送',
  setting_clear_cache: '清空缓存',
  setting_channel: '渠道设置',
  setting_discount: '优惠设置',
  setting_exit: '系统退出',
  setting_address: '地址设置',
  setting_ter_bind: '终端绑定',
  setting_lang: '语言切换',
  setting_settle: '结算',
  setting_update: '更新',
  tip_amount: '小费金额',
  print_bill_title: '打印账单',
  print_bill_start: '开始时间',
  print_bill_end: '结束时间',
  print_bill_total: '打印汇总',
  print_bill_detail: '打印明细',
  print_bill_need_date: '请选择开始和结束时间',
  print_bill_success: '打印成功',
  print_bill_fail: '打印失败',

  password_title: '安全验证',
  password_need_6: '密码为 6 位数字',
  password_wrong: '密码错误',

  ter_bind_title: '参数设置',
  ter_bind_trade_url: '交易地址',
  trade_url_pick: '选择',
  trade_url_pick_title: '选择交易地址',
  trade_url_env_prod: '生产环境',
  trade_url_env_uat: 'UAT 环境',
  trade_url_env_dev: '开发环境',
  trade_url_input_hint: '选择、扫码或手动输入',
  ter_bind_platform: '平台号',
  ter_bind_outlet: '营业点',
  ter_bind_comm_mode: '通信模式',
  ter_bind_poll: '轮询(稳定)',
  ter_bind_push: '推送(速度)',
  ter_bind_day_poll: '白天轮询(秒)',
  ter_bind_night_poll: '夜间轮询(秒)',
  ter_bind_push_url: '推送地址',
  ter_bind_more: '更多设置',
  ter_bind_zbf: '桌边付',
  ter_bind_auto_submit: '自动提交',
  ter_bind_throttle: '节流模式',
  ter_bind_once: '单次交互',
  ter_bind_self_cashier: '自主收银',
  ter_bind_mask: '启用遮罩',
  ter_bind_pre_upload: '预上送',
  ter_bind_auth_complete_print: '预授权完成是否打印',
  ter_bind_add_auth_print: '预授权追加是否打印',
  ter_bind_wait_time: '倒计时(秒)',
  ter_bind_reprint_num: '打印联数',
  ter_bind_remark_space: '备注空格',
  ter_bind_auth_pwd: '权限密码',
  ter_bind_discount_url: '优惠地址',
  ter_bind_remark_space_ph: '备注空格行数',
  ter_bind_auth_pwd_ph: '退款、撤销时权限密码,6位纯数字',
  ter_bind_open_hidden: '打开隐藏参数',
  ter_bind_close_hidden: '关闭隐藏参数',
  ter_bind_save_ok: '保存成功',

  ter_info_title: '设备信息',
  ter_info_version: '软件版本：',
  ter_info_vendor: '设备厂商：',
  ter_info_sn: '硬件序列号：',
  ter_info_model: '设备机型：',
  ter_info_os: 'OS版本：',
  ter_info_net: '网格类型：',
  ter_info_wifi: 'wifi',
  ter_info_mobile: '移动',
  ter_info_desktop: '智能桌面版本：',
  ter_info_lng: '经度：',
  ter_info_lat: '纬度：',
  ter_info_city_code: '城市码：',
  ter_info_city_name: '城市名称：',
  ter_info_address: '地址：',

  upload_title: '日志上送',
  upload_pick_day: '请选择一天',
  upload_btn: '上送日志',
  upload_log: '日志',
  upload_data: '数据',
  upload_need_date: '请选择日期',
  upload_need_type: '至少选择一个文件类型',
  upload_fail: '上传失败,联系技术人员',

  delcache_title: '清空缓存',
  delcache_btn: '清除缓存',
  delcache_clear: '清除',
  delcache_confirm: '即将清除半年前的记录?',

  seturl_title: '设置',
  seturl_address: '通讯地址',
  seturl_scanable: '可扫码',
  seturl_success: '设置成功',

  channel_title: '渠道设置',
  channel_success: '设置成功',

  discount_bind_title: '终端绑定',
  discount_id_code: '身份码',
  discount_scan_qr: '请扫码二维码获取',
  discount_term_code: '终端码',
  discount_mch_name: '商户名称',
  discount_mch_no: '商户号',
  discount_term_name: '终端名称',
  discount_org_id: '组织ID',
  discount_inst_id: '机构ID',
  discount_term_id: '终端ID',
  discount_bound: '已绑定',
  discount_bind: '绑定',

  maintenance_title: '维护手册',
  push_title: '推送设置',
  push_bank_void: '是否支持银行卡当日撤销',

  poll_retry: '重试',
  poll_check_config: '检查配置',
  poll_net_retry: '网络异常 {0} 后重连',

  cashier_title: '快速收银',
  cashier_bank: '银行卡',
  cashier_qr: '二维码',
  cashier_switch: '(点击切换)',
  cashier_need_expr: '请输入算式',
  cashier_need_equal: '请先按等于号计算',
  cashier_need_amount: '请输入金额',
  cashier_pay: '收款',
  cashier_done: '完成',
  cashier_union_qr: '银联二维码',
  cashier_wechat: '微信',
  cashier_alipay: '支付宝',
  cashier_other: '其他',

  query_title: '查询',
  query_trade_detail: '交易明细',
  query_unknown: '未知交易',
  query_icbc: '工银收单明细',
  query_discount: '优惠明细',
  query_act: '活动查询',
  query_luckdraw: '中奖查询',
  query_bank_flow: '银行流水',
  query_bank_unknown: '查询银行卡未知交易',
  query_qr_unknown: '查询二维码未知交易',
  query_mch_discount: '查询商户优惠信息',
  query_notify_exc: '异常推送',
  query_notify_exc_mis: '异常上送',

  trade_type: '交易类型',
  trade_type_colon: '交易类型：',
  trade_ref_no: '检索参考号',
  trade_ref_no_colon: '检索参考号:',
  trade_ref_no_origin: '原交易的检索参考号',
  trade_amount: '交易金额',
  trade_amount_colon: '交易金额：',
  trade_order_no: '商户订单号',
  trade_order_no_colon: '商户订单号:',
  trade_order_no_local: '本机订单号',
  trade_order_no_ph: '请输入商户订单号',
  trade_time: '交易时间',
  trade_time_colon: '交易时间:',
  trade_card: '交易卡号',
  trade_card_colon: '交易卡号:',
  trade_card_no: '卡号',
  trade_card_ph: '请输入卡号',
  trade_get_card: '获取卡号',
  trade_read_card: '读卡',
  trade_read_card_hint: '刷卡/插卡/手输',
  trade_success: '交易成功',
  trade_fail: '交易失败',
  trade_unknown: '未知',
  trade_upload_ok: '上送成功',
  trade_upload_fail: '上送失败',
  trade_bank: '银行卡',
  trade_qr: '二维码',
  trade_print: '打印凭证',
  trade_reprint: '补打凭证',
  trade_reupload: '重新上送',
  trade_refund: '退款',
  trade_refunded: '已退',
  trade_upload_fail_tab: '上送失败',
  trade_unknown_tab: '未知交易',
  trade_refund_amount: '退款金额',
  trade_refund_amount_ph: '请输入退款金额,单位元',
  trade_need_refund_amount: '请输入退款金额',
  trade_need_scan_qr: '请扫二维码',
  trade_submit_ok: '提交成功',
  trade_txn_01: '消费',
  trade_txn_02: '消费撤销',
  trade_txn_03: '退货',
  trade_txn_05: '预授权',
  trade_txn_07: '预授权撤销',
  trade_txn_09: '预授权完成',
  trade_txn_11: '预授权完成撤销',
  trade_pick_date: '选择日期',
  trade_unclear: '不明确',
  trade_ok: '成功',
  trade_fail_short: '失败',
  trade_order_time: '订单时间:',
  trade_sync: '同步交易',
  trade_upload_fail_msg: '交易上传失败',
  trade_reupload_ask: '是否重新上传?',
  trade_one_key_upload: '一键上送',
  trade_resend: '重新发送',
  trade_uploading: '上送中',
  trade_method: '交易方式',
  trade_mch_order: '商户订单',
  trade_order_time_label: '订单时间',
  trade_order_amount: '订单金额',
  trade_real_amount: '实际交易金额',
  trade_mch_remark: '商户备注',
  trade_op_remark: '操作备注',
  trade_print_info: '打印信息',
  trade_discount_query: '优惠查询',
  trade_submit_order: '提交订单',
  trade_discount_info: '优惠信息',
  trade_refund_break: '退款中断',
  trade_abort_ask: '确认中止订单?',
  trade_suspend_ask: '是否挂起订单，可通过补单继续交易?',
  trade_title: '交易',
  trade_reprint_title: '重打印',
  trade_pay_way: '支付方式',
  trade_detail: '详情',
  trade_acquirer: '收单行',
  trade_paid_amount: '实付金额',
  trade_discount_amount: '优惠金额',
  trade_discount_channel: '优惠通道',
  trade_act_name: '活动名称',
  trade_refund_status: '退款情况',
  trade_refund_partial: '部分退款',
  trade_refund_full: '全部退款',
  trade_refund_times: '退款次数',
  trade_refund_total: '退款总额',
  trade_void_today: '当日撤销',
  trade_refund_txn: '交易退款',
  trade_unknown_query: '未知查询',
  trade_waiting: '等待',
  trade_fail_status: '失败',
  trade_ok_status: '成功',
  trade_process_ok: '处理成功',
  trade_repush: '补单',

  act_title: '优惠活动',
  act_ongoing: '进行中',
  act_history: '未开始/历史',
  act_not_start: '未开始',
  act_minus: '减',
  act_discount: '折',
  act_cap: '封顶',
  act_start: '开始时间：',
  act_end: '结束时间：',

  discashier_title: '优惠交易',
  discashier_amount: '金额',
  discashier_amount_ph: '请输入支付金额',
  discashier_amount_error: '输入金额有误',

  refund_title: '退款',
  refund_void_today: '当日撤销',
  refund_dis: '优惠退货',
  refund_next_day: '隔日退货',
  refund_qr: '二维码退款',
  refund_dis_title: '优惠退款',
  refund_act_order: '活动订单号',
  refund_act_order_origin: '原交易活动订单号',
  refund_next_day_title: '隔日退款',
  refund_qr_order: '订单号',
  refund_qr_order_origin: '原交易二维码订单号',
  refund_need_ref: '请输入原交易的检索参考号',

  authority_title: '交易开关控制',
  authority_bank_void: '是否支持银行卡当日撤销',
  authority_bank_refund: '是否支持银行卡隔日退货',
  authority_bank_pre_void: '是否支持银行卡预授权撤销',
  authority_bank_pre_confirm_void: '是否支持银行卡预授权确认撤销',
  authority_bank_pre_confirm_refund: '是否支持银行卡预授权确认隔日退货',
  authority_qr_void: '是否支持扫码当日撤销',
  authority_qr_refund: '是否支持扫码隔日退货',

  luck_title: '中奖查询',
  luck_act_order: '活动订单',
  luck_act_order_ph: '原优惠交易的活动订单',
  luck_need_act_order: '请填写活动订单号',
  luck_discount_info: '优惠信息',
  luck_draw_info: '抽奖信息',
  luck_order_status: '订单状态',
  luck_level: '中奖级别',
  luck_prize: '奖品',
  luck_remark: '备注',
  luck_status: '状态',
  luck_pre_deduct_ok: '优惠预扣成功',
  luck_not_won: '未中奖',
  luck_claimed: '已领奖',
  luck_unclaimed: '未领奖',
  luck_returned: '已退货',
  luck_registered: '已登记',
  trade_voided: '已撤销',

  bank_flow_title: '银行流水',
  bank_term_seq: '终端流水号',
  bank_ref_origin: '原交易检索参考号',
  bank_start: '开始时间',
  bank_end: '结束时间',
  bank_time_desc: '按时间倒序',
  bank_error: '程序错误,联系技术人员',

  qr_query_title: '二维码查询',
  qr_order_no: '订单号',
  qr_order_origin: '原交易的二维码订单号',
  qr_need_order: '请填写订单号',
  qr_synced: '本地已同步',

  quick_cashier_title: '快速收银',
  quick_cashier_no: '单号:',

  connect_reconnect: '立即重连',
  connect_retry_ss: '连接中断 {0} 后重连',
  connect_fail_ss: '连接失败 {0} 后重连',
  connect_fail: '连接失败',
  connect_ok: '连接成功',

  discount_act_colon: '优惠活动:',
  discount_order_colon: '优惠订单号:',
  discount_order_local: '本机/优惠订单号'
}



// WEBPACK FOOTER //
// ./src/locale/zh-Hans.js